module.exports = __webpack_public_path__ + "img/40_38_031_100.efb492f3.jpg";